import PageLoadEvents from './page-load-events';
import ErrorEvents from './error-events';
import OverlayEvents from './overlay-events';
import ClickEvents from './click-events';

const pageLoadEvents = new PageLoadEvents();
const errorEvents = new ErrorEvents();
const overlayEvents = new OverlayEvents();
const clickEvents = new ClickEvents();

export {
  pageLoadEvents,
  errorEvents,
  overlayEvents,
  clickEvents
};
